import { render } from "./CIS-ResourceContent.vue?vue&type=template&id=aa4afcd2&scoped=true"
import script from "./CIS-ResourceContent.vue?vue&type=script&lang=js"
export * from "./CIS-ResourceContent.vue?vue&type=script&lang=js"

import "./CIS-ResourceContent.vue?vue&type=style&index=0&id=aa4afcd2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa4afcd2"]])

export default __exports__